import React, { PureComponent } from 'react';
import { replaceState } from '../../../utilities/url';
import api from '../../../common/services/api';
import ContributeForm from '../components/ContributeForm';
import GiftListSearchForm from '../components/GiftListSearchForm';
import IData from '../interfaces/IData';

declare global {
    interface Window {
        dataLayer: any;
    }
}

interface IProps {
    headerMessage: string;
    ctaThankYouLink: string;
    optInMessage: string;
}

interface IState {
    data: IData;
    inputValue: string;
    isLoading: boolean;
    hasError: boolean;
}

class ContributeGiftList extends PureComponent<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            inputValue: '',
            data: null,
            isLoading: false,
            hasError: false
        };
        this.updateInputValue = this.updateInputValue.bind(this);
        this.getGiftListContribute = this.getGiftListContribute.bind(this);

    }

    componentDidMount() {
        if (this.UrlSlug !== 'contribute') {
            this.getGiftListContribute(this.UrlSlug);
        }
    }

    get UrlSlug() {
        const urlPath = window.location.pathname.split('/');
        return urlPath[urlPath.length - 1];
    }

    getGiftListContribute(giftListCode: string) {
        this.setState({
            isLoading: true
        });

        api.getGiftListContribute(giftListCode)
            .then((data: any) => {
                const currentURL = window.location.href;
                if (data.status !== false) {
                    this.setState({
                        data,
                        isLoading: false,
                        hasError: false,
                        inputValue: ''
                    });

                    if (this.UrlSlug !== giftListCode) {
                        const urlQueryParams = currentURL.split("?")
                        const giftListCodeUrl = `${urlQueryParams[0]}/${giftListCode}`;
                        const setQueryParams = urlQueryParams[1] ? `${giftListCodeUrl}?${urlQueryParams[1]}` : giftListCodeUrl;

                        replaceState(setQueryParams);
                    }
                } else {
                    this.setState({
                        hasError: true,
                        isLoading: false,
                        inputValue: giftListCode
                    });

                    if (this.UrlSlug !== 'contribute') {
                        const withoutGiftListCodeURL = currentURL.substring(0, currentURL.lastIndexOf('/'));
                        replaceState(withoutGiftListCodeURL);
                    }
                }
            })
            .catch(console.error);
    }

    updateInputValue(e: React.ChangeEvent<HTMLInputElement>) {
        this.setState({
            inputValue: e.target.value
        });
    }

    render() {
        const { hasError, data, isLoading } = this.state;
        const { headerMessage, ctaThankYouLink, optInMessage } = this.props;

        if (isLoading && !hasError && this.UrlSlug !== 'contribute') {
            return <div className="pageLoading" />;
        }

        if (data && !hasError) {
            return <ContributeForm data={data} ctaThankYouLink={ctaThankYouLink} optInMessage={optInMessage} />;
        }

        return (
            <GiftListSearchForm
                getGiftListContribute={this.getGiftListContribute}
                isLoading={isLoading}
                hasError={hasError}
                headerMessage={headerMessage}
            />
        );
    }
}

export default ContributeGiftList;
